import {dateFormatsListItems} from '../../../../util/uiconstants';

export default () => dateFormatsListItems.map(({label, id}) => ({id: id === 0 ? 999 : id, value: id, label: label}));
